class ReviewSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.js-reviews-slider');
    this.prevBtn = this.querySelector('.slider-arrow-prev');
    this.nextBtn = this.querySelector('.slider-arrow-next');
    this.swiper = null;
  }

  connectedCallback() {
    if (!this.slider) return;

    const disableSlider = this.dataset.disableSlider === 'true';

    if (disableSlider) {
      // Make sure arrows are hidden
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      return;
    }

    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoHeight: true,

      navigation: {
        prevEl: this.prevBtn,
        nextEl: this.nextBtn
      },

      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 10
        }
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('review-slider')) {
  customElements.define('review-slider', ReviewSlider);
}


class CustomCollection extends HTMLElement {
  constructor() {
    super();
    this.swipers = {};
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initActiveTab();
    this.initTabs();
    this.initArrows();
  }

  initSwiper(carousel) {
    const tab = carousel.closest('[tab-content-element]');
    if (!tab) return;

    const id = tab.id;

    if (this.swipers[id]) {
      this.swipers[id].update();
      return;
    }

    this.swipers[id] = new Swiper(carousel, {
      slidesPerView: 2,        // Mobile
      spaceBetween: 10,
      loop: true,
      watchOverflow: true,
      direction: 'horizontal',
      breakpoints: {
        750: {
          slidesPerView: 3,    // Desktop
          spaceBetween: 10
        }
      }
    });
  }

  initActiveTab() {
    this.querySelectorAll('.active[tab-content-element] .product-carousel')
      .forEach(carousel => this.initSwiper(carousel));
  }

  initTabs() {
    this.querySelectorAll('[tab-button-element]').forEach(btn => {
      btn.addEventListener('click', () => this.switchTab(btn));
    });
  }

  switchTab(btn) {
    this.querySelectorAll('[tab-button-element]').forEach(t =>
      t.classList.remove('active')
    );
    this.querySelectorAll('[tab-content-element]').forEach(c =>
      c.classList.remove('active')
    );

    btn.classList.add('active');

    const target = this.querySelector('#tab-' + btn.dataset.target);
    if (!target) return;

    target.classList.add('active');

    target.querySelectorAll('.product-carousel')
      .forEach(carousel => this.initSwiper(carousel));

    target.querySelectorAll('card-product-slider')
      .forEach(slider => {
         console.log(slider, slider.constructor.name, slider.reinit);
        const savedColor = sessionStorage.getItem(
          'selectedSwatch-' + slider.dataset.section + '-' + slider.dataset.product
        );

        if (savedColor && typeof slider.applyFilter === 'function') {
          slider.applyFilter(savedColor);
        }

        slider.init();
      });

  }

  initArrows() {
    const arrows = Array.from(
        this.querySelectorAll('[prev], [next], [prev-mobile], [next-mobile]')
    ).filter(arrow => !arrow.closest('card-product-slider'));
    arrows.forEach(arrow => {
        arrow.addEventListener('click', () => {
          const dir = arrow.hasAttribute('prev') || arrow.hasAttribute('prev-mobile')
            ? 'prev'
            : 'next';
          this.move(dir);
        });
      });
  }

  move(direction) {
    const activeTab = this.querySelector('.active[tab-content-element]');
    if (!activeTab) return;

    const swiper = this.swipers[activeTab.id];
    if (!swiper) return;

    direction === 'prev' ? swiper.slidePrev() : swiper.slideNext();
  }

  disconnectedCallback() {
    Object.values(this.swipers).forEach(swiper => swiper.destroy());
  }
}

customElements.define('custom-collection', CustomCollection);

class CardProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.slider = null;
    this.parentCollection = null;
  }

  connectedCallback() {
    if (this.swiper) return;

    this.slider = this.querySelector('.swiper');
    if (!this.slider) return;

    this.parentCollection = this.closest('custom-collection');
    this.init();
  }

  init() {
    this.destroy();
    this.initSwiper();
    this.initArrows();
    this.onChange();
  }

  updatePaginationGroups() {
    const bullets = this.querySelectorAll('.swiper-pagination-bullet');
    if (!bullets.length) return;

    const groupSize = 3;
    const swiper = this.swiper;
    const activeIndex = swiper.realIndex;

    const groupStart = Math.floor(activeIndex / groupSize) * groupSize;
    const groupEnd = groupStart + groupSize;

    bullets.forEach((bullet, index) => {
      bullet.style.display =
        index >= groupStart && index < groupEnd ? 'inline-block' : 'none';
    });
  }

  applyFilter(color) {
    const slides = this.querySelectorAll('.swiper-slide-main');

    slides.forEach(slide => {
      slide.classList.toggle(
        'swiper-slide',
        slide.dataset.color === color
      );

      slide.style.display =
        slide.dataset.color === color ? '' : 'none';
    });
  }


  initSwiper() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      loop: true,
      autoHeight: false,
      nested: true,
      direction: 'horizontal',
      observer: true,
      observeParents: true,
      touchStartPreventDefault: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    });
    this.updatePaginationGroups();
  }

  onChange() {
    this.swiper.on('slideChange', () => {
      const swiper = this.swiper;
      const index = swiper.realIndex;

      this.updatePaginationGroups();

      const currentSlide = swiper.slides[swiper.activeIndex];

      let activeimage = currentSlide.querySelector('img');
      if(activeimage){
        const dataSrc = activeimage.dataset.src;
        const dataSrcset = activeimage.dataset.srcset;
        if (dataSrc && activeimage.getAttribute('src') !== dataSrc) {
          activeimage.src = dataSrc;
        }
        if (dataSrcset && activeimage.getAttribute('srcset') !== dataSrcset) {
          activeimage.srcset = dataSrcset;
        }
        activeimage.classList.add('is-loaded');
      }
    });
  }

  initArrows() {
    const prevBtn = this.querySelector('[prev]');
    const nextBtn = this.querySelector('[next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', e => {
        e.preventDefault();
        this.swiper?.slidePrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', e => {
        e.preventDefault();
        this.swiper?.slideNext();
      });
    }
  }

  rebuild() {
    this.init();
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  disconnectedCallback() {
    this.destroy();
  }
}

customElements.define('card-product-slider', CardProductSlider);


class CustomSwatches extends HTMLElement {
  constructor() {
    super();
    this.onInputChange = this.onInputChange.bind(this);
  }

  connectedCallback() {
    this.radios = this.querySelectorAll('input[type="radio"][data-variant-id]');
    this.radios.forEach(radio => {
      radio.addEventListener("change", this.onInputChange);
    });

    const anyRadio = this.radios[0];
    if (!anyRadio) return;

    const productId = anyRadio.getAttribute("data-product-id");
    const sectionId = anyRadio.getAttribute("data-section-id");

    const savedVariantId =
      sessionStorage.getItem(`selectedVariant-${sectionId}-${productId}`) ||
      sessionStorage.getItem(`selectedSwatch-${sectionId}-${productId}`);

    let radioToActivate = null;

    // 1️⃣ sessionStorage wins
    if (savedVariantId) {
      radioToActivate = this.querySelector(
        `input[type="radio"][data-variant-id="${savedVariantId}"]`
      );
    }

    // 2️⃣ already-checked radio in DOM
    if (!radioToActivate) {
      radioToActivate = this.querySelector(
        'input[type="radio"][data-variant-id]:checked'
      );
    }

    // 3️⃣ fallback to first radio
    if (!radioToActivate) {
      radioToActivate = this.radios[0];
      radioToActivate.checked = true;
    }

    // 🔥 ALWAYS run logic on load
    if (radioToActivate) {
      this.onInputChange({ target: radioToActivate });
    }
  }

  loadVariantData(productId, variantId) {
    const scriptTag = document.querySelector(`script[data-product-id='${productId}']`);

    if (!scriptTag) {
      console.warn(`Script tag for product ${productId} not found.`);
      return null;
    }

    const scriptContent = scriptTag.textContent;

    // Match: var variantDataMap = { ... };
    const match = scriptContent.match(/var\s+variantDataMap\s*=\s*(\{[\s\S]*?\});/);

    if (!match || !match[1]) {
      console.warn(`Could not parse variantDataMap for product ${productId}`);
      return null;
    }

    let variantMap;
    try {
      variantMap = JSON.parse(match[1]);
    } catch (err) {
      console.error(`JSON parse error for product ${productId}:`, err);
      return null;
    }

    return variantMap[variantId] || null;
  }

  getProductMediaArray(productId) {
    const script = document.querySelector(`script[data-product-id='${productId}']`);
    if (!script) return [];

    const scriptContent = script.textContent;

    const match = scriptContent.match(/var\s+productMedia\s*=\s*(\[[^\]]+\])/);
    if (!match) return [];

    try {
      const mediaArray = JSON.parse(match[1].replace(/(['"])?https?:/g, '')); // normalize protocol
      return mediaArray;
    } catch (e) {
      console.warn('Could not parse productMedia for product:', productId, e);
      return [];
    }
  }

  storeSelectedVariant(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedVariant-' + sectionId + '-' + productId, variantId);
  }

  storeSelectedSwatch(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedSwatch-' + sectionId + '-' + productId, variantId);
  }

  triggerDefaultVariant() {
    const firstChecked =
      this.querySelector('input[type="radio"][data-variant-id]:checked') ||
      this.querySelector('input[type="radio"][data-variant-id]');
    
    if (firstChecked) {
      this.onInputChange({ target: firstChecked });
    }
  }

  onInputChange(event) {
    const radio = event.target;

    const newVariantId = radio.getAttribute("data-variant-id");
    const newProductId = radio.getAttribute("data-product-id");
    const sectionId = radio.getAttribute("data-section-id");

    this.storeSelectedVariant(sectionId, newProductId, newVariantId);
    this.storeSelectedSwatch(sectionId, newProductId, newVariantId);

    const getVariantData = this.loadVariantData(newProductId, newVariantId);

    const productGrid = radio.closest("[card-product-grid]");
    
    const sliderElement = productGrid.querySelector('[card-product-slider]');
    const selectedColor = radio.value;

    if (sliderElement && selectedColor) {
      const allSlides = sliderElement.querySelectorAll('.swiper-slide-main');

      // console.log("allSlides", allSlides)
      allSlides.forEach(slide => {
        const slideColor = slide.getAttribute('data-color');
        if (slideColor == selectedColor) {
          slide.style.display = '';
          slide.classList.remove('non-swiper-slide');
          slide.classList.add('swiper-slide');
        } else {
          slide.style.display = 'none';
          slide.classList.add('non-swiper-slide');
          slide.classList.remove('swiper-slide');
        }
      });

      // Count visible slides
      const visibleSlides = sliderElement.querySelectorAll('.swiper-slide').length;

      const cardSlider = sliderElement.closest('card-product-slider');

      if (cardSlider && typeof cardSlider.rebuild === 'function') {
        cardSlider.rebuild();
      }

    }


    // Update product form variant ID
    const productForm = productGrid.querySelector('product-form');
    if (productForm) {
      const idElement = productForm.querySelector("[name='id']");
      if (idElement) idElement.value = newVariantId;
    }

    // Re-run active filter view after swatch change
    const filterView = document.querySelector("filter-view");
    if (filterView && typeof filterView.runActiveView === "function") {
      filterView.runActiveView();
    }
  }

}
customElements.define("custom-swatches", CustomSwatches);

function dropdownProducts() {
  const wrapper = document.querySelector('.dropdown-wrapper-custom');
  if (!wrapper) return console.warn('Dropdown wrapper not found');
  const button = wrapper.querySelector('.dropdown-button'), menu = wrapper.querySelector('#dropdownMenu');
  button.addEventListener('click', () => wrapper.classList.toggle('show'));
  document.addEventListener('click', e => { if (!wrapper.contains(e.target)) wrapper.classList.remove('show'); });
  menu.querySelectorAll('.dropdown-item').forEach(item => item.addEventListener('click', () => wrapper.classList.remove('show')));
}
dropdownProducts();


class AccordionWrapper extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.accordion-item');
  }

  connectedCallback() {
    this.items.forEach(item => {
      const question = item.querySelector('.accordion-question');

      question.addEventListener('click', () => {
        this.toggleItem(item);
      });
    });
  }

  toggleItem(activeItem) {
    this.items.forEach(item => {
      const answer = item.querySelector('.accordion-answer');

      if (item === activeItem) {
        if (item.classList.contains('active')) {
          // Close
          answer.style.maxHeight = null;
          item.classList.remove('active');
        } else {
          // Open
          answer.style.maxHeight = answer.scrollHeight + 'px';
          item.classList.add('active');
        }
      } else {
        // Close others
        item.classList.remove('active');
        answer.style.maxHeight = null;
      }
    });
  }
}
customElements.define('accordion-wrapper', AccordionWrapper);


document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.announcement-carousel');

  if (!swiperEl) return;

  new Swiper(swiperEl, {
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: swiperEl.closest('.announcement-bar-wrapper').querySelector('.announcement-carousel-arrow--next'),
      prevEl: swiperEl.closest('.announcement-bar-wrapper').querySelector('.announcement-carousel-arrow--prev'),
    },
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // Select all menu items
  var menuItems = document.querySelectorAll('.tr-flex-item > a');
  var menuParent = document.querySelector('.tr-nav-flex'); // use single container (not NodeList)

  menuItems.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var megaMenu = this.parentElement.querySelector('.tr-mega-menu'); // Associated mega menu

      if (megaMenu) {
        e.preventDefault(); // Prevent link navigation only if it has a mega menu

        var isVisible = megaMenu.style.visibility === 'visible';

        // Hide all other mega menus
        document.querySelectorAll('.tr-mega-menu').forEach(function (menu) {
          menu.style.opacity = '0';
          menu.style.visibility = 'hidden';
        });

        // Remove "menu-open" class from parent
        menuParent.classList.remove('menu-open');

        console.log("isVisible000-0-");

        // If it was closed before → open it
        if (!isVisible) {
          megaMenu.style.opacity = '1';
          megaMenu.style.visibility = 'visible';
          menuParent.classList.add('menu-open'); // ✅ add class when open
        }
      } else {
        // Normal navigation for links without mega menus
        return true;
      }
    });
  });

  // Optional: Close mega menu if clicked outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.tr-flex-item')) {
      document.querySelectorAll('.tr-mega-menu').forEach(function (menu) {
        menu.style.opacity = '0';
        menu.style.visibility = 'hidden';
      });
      document.querySelector('.tr-nav-flex')?.classList.remove('menu-open'); // ✅ remove class when clicking outside
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.hero-slider', {
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.hero-slider .swiper-pagination',
      clickable: true
    }
  });
});

document.querySelectorAll('.footer-block__heading').forEach(function(heading) {
  heading.addEventListener('click', function() {
    if (window.innerWidth < 750) {
      const block = heading.parentElement;
      const content = block.querySelector('.footer-block__content');

      block.classList.toggle('active');

      if (block.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 16 + "px";
      } else {
        content.style.maxHeight = 0;
      }
    }
  });
});